import Profile from "./Profile";

export default function SearchedProfile({ findUser, type, tab, display }) {
  return (
    <Profile findUser={findUser} type={type} tab={tab} display={display} />
  );
}
